import toggleModal from '@/scripts/utils/toggle-modal';

class HeaderNav {
  constructor(options) {
    this.menuSelector = options.menuSelector;
    this.menu = document.querySelector(options.menuSelector);
    this.menuContainer = document.querySelector(options.menuContainer); // inner
    this.menuWrapperSelector = options.menuWrapper; // outer
    this.menuList = this.menuContainer.querySelector(options.menuList);
    this.transitionDuration = options.transitionDuration;
    if (options.menuItemDecoration) {
      this.menuItemDecoration = options.menuItemDecoration;
    }
  }

  toggleStatus() {
    const header = document.querySelector('header');
    if (header.classList.contains('opened')) {
      header.classList.remove('opened');
    } else {
      header.classList.add('opened');
    }
    return toggleModal(header.classList.contains('opened'), this.menuSelector);
  }

  init() {
    const header = document.querySelector('header');
    const hamburger = document.querySelector('.hamburger-container');
    let prevPosition = 0;
    window.scrollTo(0, 1);

    // const cover = document.querySelector('.cover');
    // if (!cover || cover.classList.contains('cover-slider_article')) {
    //   hamburger.classList.add('hamburger-container_border');
    // }

    hamburger.addEventListener('click', (e) => {
      this.toggleStatus(e);
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest(this.menuWrapperSelector) && header.classList.contains('opened')) {
        this.toggleStatus();
      }
    });
    $(document).on('scroll', () => {
      const position = window.pageYOffset;

      if (position > prevPosition && position > 1) {
        header.classList.add('is-scroll');
        // header.classList.add('header_hide'); //hide header when we scroll down
      } else if (position < 100) {
        header.classList.remove('is-scroll');
        // header.classList.remove('header_hide');
      }
      // else {
      //   header.classList.add('is-scroll');
      // header.classList.remove('header_hide');
      // }
      prevPosition = position;
    });
  }
}

export default function initHeaderNav(options) {
  const defaults = {
    menuSelector: '.menu',
    menuContainer: '.menu__container', // inner
    menuWrapper: '.menu__wrapper', // outer
    menuItemDecoration: '.line',
    transitionDuration: 450,
  };
  const headerNav = new HeaderNav(Object.assign({}, defaults, options));
  headerNav.init();
}




// WEBPACK FOOTER //
// ./scripts/elements/header-nav.js